import { defineMessages } from 'react-intl';

export default defineMessages({
    cancelChangeTitle:{
        "id":"payrollreporting.requestchangeCancel.Cancel payroll report change request",
        "defaultMessage":"Cancel payroll report change request"
    },
    cancelChangeMessage:{
        "id":"payrollreporting.requestchangeAre.Are you sure you want to cancel your payroll report change request?",
        "defaultMessage":"Are you sure you want to cancel your payroll report change request?"
    },
    Title:{
        "id":"payrollreporting.requestchangeError.Error entering Input",
        "defaultMessage":"Input Field Error"

    },
    errorMessage:{
        "id":"payrollreporting.requestchangeError1.Error entering Input message",
        "defaultMessage":"Please enter all the mandatory fields to proceed further"
    }
});